import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Static head tags serve non-JS crawlers; per-route <Seo> replaces them once React runs.
document.querySelectorAll("[data-static-seo]").forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
